export function fetchGetProduct(pid) {
  if (pid === "674" || pid === "705") {
    return fetch(
      `${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?gid=` + pid
    )
      .then((response) => response.json())
      .catch((error) => {
        console.log(error);
      });
  } else {
    return fetch(
      `${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?pid=` + pid
    )
      .then((response) => response.json())
      .catch((error) => {
        console.log(error);
      });
  }
}
